import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import MfaSetupCard from '@/components/MfaSetupCard';

const C = { slate: '#5C6B7A', line: '#E4E9EF' };

function SecurityContent() {
  return (
    <div className="space-y-4 max-w-2xl" data-testid="security-page">
      <div className="p-5 rounded-lg border" style={{ borderColor: C.line, background: '#fff' }}>
        <div className="text-sm font-bold mb-3" style={{ color: '#0D1B2A' }}>Multi-factor authentication (TOTP)</div>
        <MfaSetupCard />
      </div>
      <div className="text-xs" style={{ color: C.slate }}>
        Ruling (7 Sep 2026): TOTP for all staff roles, enforced on platform_owner and mga_admin first, live before any real submission. Enrolled sign-ins require your authenticator code after your password; recovery codes are single-use.
      </div>
    </div>
  );
}

export default function SecurityPage() {
  const tabs = [{ id: 'mfa', label: 'MFA', content: <SecurityContent /> }];
  return <ModuleShell title="Security" subtitle="Sign-in protection for your account" tabs={tabs} />;
}
